import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Location } from '@angular/common';
import { MyTurn } from '../../player-clock/player-clock.component';
@Component({
    selector: 'circle-progress',
    templateUrl: './circle-progress.component.html',
    styleUrls: ['./circle-progress.component.scss'],
    standalone: false
})

/**
 * A UI component for showing a circular progress bar.
 * source: https://coryrylan.com/blog/angular-progress-component-with-svg
 */
export class CircleProgressComponent implements OnInit, OnChanges {
    @Input() currentProgress: MyTurn | null = { clockProgress: 0, isDealyStarted: false};
    @Input() radius = 50;
    @Input() background = '#ccc';
    @Input() color = '#1d1d1d';
    @Input() stroke = 3;
    @Input() rectDimention = 'M3,0 h154 a4,4 0 0 1 4,4 v38 a4,4 0 0 1 -4,4 h-154 a4,4 0 0 1 -4,-4 v-38 a4,4 0 0 1 4,-4 z';
    @Input() rectDimentionHalf = 'M3,0 h154 a4,4 0 0 1 4,4 v38 a4,4 0 0 1 -4,4';

    circumference: number;
    dashoffset: number;
    counter = 0;

    constructor(private platform: Platform, private location: Location) {
    }
    
    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.currentProgress && changes.currentProgress.currentValue) {
            if (changes.currentProgress.currentValue !== changes.currentProgress.previousValue) {
                this.progress(changes.currentProgress.currentValue);
            }
        } else { 
            this.progress({ clockProgress: 0, isDealyStarted: false});
        }
    }

    private progress(currentProgress: MyTurn) {
        const progress = Math.min(currentProgress.clockProgress, 100) / 100;
        this.circumference = 2 * Math.PI * this.radius;
        // this.dashoffset = this.circumference * (1 - progress);
        // if (this.dashoffset > 0) {
        // 	this.counter = 0;
        // }
        this.dashoffset = this.circumference * progress;
        // if (this.dashoffset === this.circumference) {
        //     this.counter = 0;
        // }
        if (currentProgress.isDealyStarted == true) {
            if (this.counter % 2 == 0) {
                this.stroke = 4;
                this.color = 'red';
            } else {
                this.stroke = 3;
                this.color = '#ffeb3b';
            }
            this.counter++;
        } else {
            this.stroke = 3;
            this.color = '#1d1d1d';
            // if (progress < 0.4) {
            //     this.color = '#00FF00';
            // } else if (progress < 0.5) {
            //     this.color = '#FAFF00';
            // } else if (progress > 0.7) {
            //     this.color = '#FF0000';
            // }
        }
        this.platform.ready().then(() => {
                this.rectDimention =
                    'M3,0 h154 a4,4 0 0 1 4,4 v38 a4,4 0 0 1 -4,4 h-154 a4,4 0 0 1 -4,-4 v-38 a4,4 0 0 1 4,-4 z';
                this.rectDimentionHalf = 'M3,0 h154 a4,4 0 0 1 4,4 v38 a4,4 0 0 1 -4,4';
        });
    }

    getViewBox(): string {
        return `0 0 ${this.radius * 2} ${this.radius * 2}`;
    }

    style() {
        if ( this.currentProgress === null || !this.currentProgress.isDealyStarted ) {
            return this.circumference - this.dashoffset;
        } else {
            return '0';
        }
    }

    getUrl(effect: string) {
        return `url(${this.location.path()}#${effect})`;
    }
}
